import React from 'react';

export function DocSidebarImage({ src, alt, className = '' }) {
  return (
    <div className={`doc-media doc-media--sidebar pb-10 pt-10 ${className}`.trim()}>
      <img src={src} alt={alt} className="doc-img-native" />
    </div>
  );
}

export function DocContentImage({ src, alt, className = '' }) {
  return (
    <div className={`doc-media doc-media--content pb-20 pt-10 ${className}`.trim()}>
      <img src={src} alt={alt} className="doc-img-content" />
    </div>
  );
}

export function DocInlineImage({ src, alt, className = '' }) {
  return (
    <div className={`doc-media doc-media--inline pb-10 pt-10 ${className}`.trim()}>
      <img src={src} alt={alt} className="doc-img-native" />
    </div>
  );
}

export function DocModalImage({ src, alt, className = '' }) {
  return (
    <div className={`doc-media doc-media--modal pb-20 pt-10 ${className}`.trim()}>
      <img src={src} alt={alt} className="doc-img-modal" />
    </div>
  );
}
